var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1693_6168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9473 29.4737C38.9473 30.5904 38.5037 31.6614 37.7141 32.451C36.9245 33.2406 35.8535 33.6842 34.7368 33.6842H5.26314C4.14644 33.6842 3.07547 33.2406 2.28585 32.451C1.49622 31.6614 1.05261 30.5904 1.05261 29.4737V10.5263C1.05261 9.40961 1.49622 8.33865 2.28585 7.54902C3.07547 6.7594 4.14644 6.31579 5.26314 6.31579H34.7368C35.8535 6.31579 36.9245 6.7594 37.7141 7.54902C38.5037 8.33865 38.9473 9.40961 38.9473 10.5263V29.4737Z",
    fill: "#CCD6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6316 19.6168L1.72319 31.5253C1.69477 31.5547 1.68424 31.5916 1.66003 31.6211C2.01706 32.2202 2.51776 32.7209 3.11688 33.0779C3.1474 33.0537 3.18319 33.0432 3.21161 33.0158L15.1211 21.1053C15.3185 20.9077 15.4293 20.6399 15.4292 20.3607C15.4291 20.0814 15.3181 19.8137 15.1206 19.6163C14.923 19.4189 14.6552 19.3081 14.376 19.3082C14.0967 19.3083 13.829 19.4193 13.6316 19.6168Z",
    fill: "#99AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.34 31.6211C38.3179 31.5916 38.3053 31.5547 38.2769 31.5263L26.3695 19.6168C26.2718 19.519 26.1557 19.4415 26.028 19.3885C25.9003 19.3355 25.7634 19.3083 25.6251 19.3082C25.4869 19.3082 25.3499 19.3353 25.2222 19.3882C25.0944 19.4411 24.9783 19.5186 24.8805 19.6163C24.7827 19.714 24.7051 19.8301 24.6522 19.9578C24.5992 20.0855 24.5719 20.2224 24.5719 20.3607C24.5719 20.4989 24.599 20.6359 24.6519 20.7636C24.7048 20.8914 24.7823 21.0075 24.88 21.1053L36.7884 33.0147C36.8168 33.0432 36.8537 33.0537 36.8832 33.0779C37.4828 32.7215 37.9836 32.2206 38.34 31.6211Z",
    fill: "#99AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7368 6.31579H5.26314C4.14644 6.31579 3.07547 6.7594 2.28585 7.54902C1.49622 8.33865 1.05261 9.40961 1.05261 10.5263V11.6105L16.3452 26.8684C17.3078 27.8262 18.6105 28.3639 19.9684 28.3639C21.3263 28.3639 22.629 27.8262 23.5916 26.8684L38.9473 11.5884V10.5263C38.9473 9.40961 38.5037 8.33865 37.7141 7.54902C36.9245 6.7594 35.8535 6.31579 34.7368 6.31579Z",
    fill: "#99AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7368 6.3158H5.26309C4.47071 6.31756 3.69497 6.54333 3.02539 6.96705C2.35582 7.39078 1.81969 7.99518 1.47888 8.71053L17.022 24.2547C17.413 24.6457 17.8772 24.9559 18.3881 25.1675C18.8989 25.3791 19.4465 25.4881 19.9994 25.4881C20.5524 25.4881 21.0999 25.3791 21.6108 25.1675C22.1216 24.9559 22.5858 24.6457 22.9768 24.2547L38.521 8.71053C38.1803 7.99511 37.6442 7.39063 36.9746 6.96689C36.305 6.54315 35.5292 6.31743 34.7368 6.3158Z",
    fill: "#E1E8ED"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1693_6168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6017 17.1811L36.8517 32.9683H34.8417L34.0617 17.1811H37.6017ZM34.4517 38.8651C34.0717 38.4699 33.8817 37.9915 33.8817 37.4299C33.8817 36.8683 34.0717 36.3899 34.4517 35.9947C34.8317 35.5787 35.2917 35.3707 35.8317 35.3707C36.3717 35.3707 36.8317 35.5787 37.2117 35.9947C37.6117 36.3899 37.8117 36.8683 37.8117 37.4299C37.8117 37.9915 37.6117 38.4699 37.2117 38.8651C36.8317 39.2603 36.3717 39.4579 35.8317 39.4579C35.2917 39.4579 34.8317 39.2603 34.4517 38.8651Z",
    fill: "#F79E1B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1693_6168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1693_6168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 26,
    fill: "white",
    transform: "translate(33.34 15.9019)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.40e3b62892ddc15f75e8bcd83ebb81ac.svg";
export { ForwardRef as ReactComponent };